import { QueryClientProvider } from "@tanstack/react-query";
import { ReactQueryDevtools } from "@tanstack/react-query-devtools";
import { queryClient } from "@/tanstack-db/query-client";
import type { ReactNode } from "react";
import { useViewportSync } from "@/tanstack-db/dbHooks";

// Import collections to trigger initialization (will be added in phases)
import "@/tanstack-db/collections";

interface DatabaseProviderProps {
  children: ReactNode;
}

export function DatabaseProvider({ children }: DatabaseProviderProps) {
  // Sync viewport state with browser matchMedia
  useViewportSync();

  return (
    <QueryClientProvider client={queryClient}>
      {children}
      {import.meta.env.DEV && <ReactQueryDevtools initialIsOpen={false} />}
    </QueryClientProvider>
  );
}
